import React from 'react'
import 'app/sm/progress_application/components/section_container/style.scss'

const SectionContainer = ({ children }) => {
  return <div className="section-container">{children}</div>
}

export default SectionContainer
